"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { sendCommerceActivity, type CommerceBrowserActivity } from "./activity-client"

const CHECKOUT_RECOVERY_PATH = /^\/(?:[a-z]{2}\/)?checkout\/recover\/?$/i

function send(activity: CommerceBrowserActivity): void {
  void sendCommerceActivity(activity).catch(() => undefined)
}

export default function ActivityTracker() {
  const pathname = usePathname() || "/"
  const trackingDisabled = CHECKOUT_RECOVERY_PATH.test(pathname)

  useEffect(() => {
    if (trackingDisabled) return
    send({ action: "navigation", path: pathname })
  }, [pathname, trackingDisabled])

  useEffect(() => {
    if (trackingDisabled) return
    const onClick = () => send({ action: "click", path: pathname })
    const onSubmit = () => send({ action: "form_submit", path: pathname })
    document.addEventListener("click", onClick, { passive: true })
    document.addEventListener("submit", onSubmit, true)
    return () => {
      document.removeEventListener("click", onClick)
      document.removeEventListener("submit", onSubmit, true)
    }
  }, [pathname, trackingDisabled])

  return null
}
